import React from 'react';
import { Text } from 'ink';
import { ConnectionState } from '../../types';
import type { McpPanelServerItem } from '../../types';
import { useTheme } from '../theme';

interface McpStatusIndicatorProps {
  mcpServers?: McpPanelServerItem[];
}

export const McpStatusIndicator: React.FC<McpStatusIndicatorProps> = React.memo(
  ({ mcpServers }) => {
    const { tokens } = useTheme();
    if (!mcpServers || mcpServers.length === 0) return null;

    const total = mcpServers.length;
    const connected = mcpServers.filter(
      (s) => s.connectionState === ConnectionState.Connected,
    ).length;
    const errored = mcpServers.filter(
      (s) =>
        s.connectionState === ConnectionState.Failed ||
        s.connectionState === ConnectionState.Disconnected,
    ).length;

    let color: string;
    if (connected === total) {
      color = tokens.text.success;
    } else if (errored > 0) {
      color = tokens.text.danger;
    } else {
      color = tokens.text.warning;
    }

    return (
      <Text dimColor color={color}>
        MCP: {connected}/{total}
      </Text>
    );
  },
);
